import { CreateInvestmentJurisdictionRequest } from '../../../../web-api-client';
import { InvestmentJurisdiction } from '../../models';

export const mapInvestmentJurisdictionToCreateRequest = (
  investmentJurisdiction: InvestmentJurisdiction
): CreateInvestmentJurisdictionRequest => {
  return new CreateInvestmentJurisdictionRequest({
    countryId: investmentJurisdiction.country!.countryId!,
    isActive: investmentJurisdiction.isActive,
    isDisplay: investmentJurisdiction.isDisplay,
  });
};
